import { render, staticRenderFns } from "./ModalViewSettlementCollection.vue?vue&type=template&id=5d0d0759&"
import script from "./ModalViewSettlementCollection.vue?vue&type=script&lang=js&"
export * from "./ModalViewSettlementCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports